var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Delete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M19.3249 9.4668C19.3249 9.4668 18.7819 16.2018 18.4669 19.0388C18.3169 20.3938 17.4799 21.1878 16.1089 21.2128C13.4999 21.2598 10.8879 21.2628 8.27991 21.2078C6.96091 21.1808 6.13791 20.3768 5.99091 19.0458C5.67391 16.1838 5.13391 9.4668 5.13391 9.4668",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M20.7082 6.23828H3.75024",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M17.4407 6.239C16.6557 6.239 15.9797 5.684 15.8257 4.915L15.5827 3.699C15.4327 3.138 14.9247 2.75 14.3457 2.75H10.1127C9.5337 2.75 9.0257 3.138 8.8757 3.699L8.6327 4.915C8.4787 5.684 7.8027 6.239 7.0177 6.239",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9d8427af3bfcf5bb3651b47d21c7c2da.svg";
export { ForwardRef as ReactComponent };